import {FormWindow} from "@intermesh/groupoffice-core";
import {
	ArrayField,
	arrayfield,
	ArrayUtil,
	btn,
	ContainerField,
	containerfield,
	fieldset,
	h4,
	numberfield,
	router, sortable,
	Sortable,
	t,
	tbar,
	textfield
} from "@intermesh/goui";
import {ColumnDialog} from "./ColumnDialog.js";
import {Board} from "./Index";

export class BoardDialog extends FormWindow {
	private columnsArrayField: ArrayField;

	constructor() {
		super("Board");

		this.title = t("Board");
		this.width = 800;
		this.height = 700;
		this.stateId = "kanban-board-dialog";

		this.modal = true;
		this.resizable = true;

		this.generalTab.items.add(
			fieldset({
					flex: 1,
					title: t("General")
				},
				textfield({
					name: "name",
					label: t("Name"),
					required: true
				}),
				numberfield({
					name: "retentionDays",
					label: t("Retention days"),
					value: 14,
					decimals: 0
				})
			),
			fieldset({},
				h4({
					text: t("Columns")
				}),
				this.columnsArrayField = arrayfield({
					name: "columns",
					listeners: {
						render: ({target}) => {

							sortable({
								component: target,
								sortableChildSelector: ".statusSort"
							})
								.on("sort", ({toIndex, fromIndex}) => {
								target.value = ArrayUtil.move(target.value, fromIndex, toIndex);
								target.value.forEach((col, index) => {
									col.sortOrder = index;
								});
							})
								.connect();
						}
					},
					buildField: () => {
						return this.buildColumnContainerField();
					}
				}),
				tbar({},
					'->',
					btn({
						icon: "add",
						text: t("New column"),
						handler: () => {
							const sortOrder = Math.max(...this.columnsArrayField.value.map(v => v.sortOrder)) + 1;

							this.columnsArrayField.addValue({
								label: t("New column"),
								sortOrder: sortOrder
							});
						}
					})
				)
			)
		);

		if (this.form.isNew) {
			this.form.value = {
				columns: [
					{
						label: t("TODO"),
						sortOrder: 0,
						isFinal: false
					},
					{
						label: t("Doing"),
						sortOrder: 1,
						isFinal: false
					},
					{
						label: t("Done"),
						sortOrder: 2,
						isFinal: true
					}
				]
			}
		}

		this.form.on("save", async ({data}) => {
			router.goto("kanban/" + data.id);
		});

		this.addSharePanel();
	}

	private buildColumnContainerField() {
		const field = containerfield({
				cls: "group statusSort",
			},
			textfield({
				itemId: "label",
				name: "label",
				label: t("Label"),
				flex: 1
			}),
			btn({
				icon: "edit",
				handler: () => {
					const board = this.form.value as Board;

					const dlg = new ColumnDialog(board);
					dlg.load(field.value);

					dlg.form.on("submit", ({target}) => {
						field.value = target.value;
						dlg.close();
					});

					dlg.show();
				}
			}),
			btn({
				itemId: "deleteBtn",
				icon: "delete",
				handler: () => {
					field.remove();
				}
			}),
			btn({
				itemId: "handle",
				cls: "handle",
				icon: "drag_handle",
				title: "sort",
				listeners: {
					render: ({target}) => {
						target.el.addEventListener("mousedown", () => {
							const row = target.findAncestorByType(ContainerField)!
							row.el.draggable = true;
						});

						target.el.addEventListener("mouseup", () => {
							const row = target.findAncestorByType(ContainerField)!
							row.el.draggable = false;
						});
					}
				}
			})
		);

		return field;
	}
}